// this file is generated by update_shopify_store_data.py at 2026-06-22 20:28:53.961811
var courses = [
    {
        "course_id": "4F6EE40A-9688-EE11-9987-005056A725AD",
        "course_version": 2,
        "name": "ANA: Nurse Executive-Advanced Certification (NEA-BC\u00ae) PracticeIQ",
        "course_type": 1,
        "author_information": "",
        "description": "Prepare for the NEA-BC\u00ae exam with confidence by quizzing yourself on over 200 practice questions covering essential areas:\r\n\r\nI. Leadership\r\nII. Quality and Safety\r\nIII. Human Capital Management\r\nIV. Health Care Delivery\r\n\r\n\r\nThe PracticeIQ allows you to tailor your study sessions to your needs, offering the flexibility to practice with the full question set or focus on specific Content Domain areas. Whether you choose to go through the PracticeIQ once or retake it as many times as you need, you can access this powerful tool anytime through the 24/7 learning portal.\r\n\r\n\r\nDeveloped and peer-reviewed by subject-matter experts with advanced education and certification in the specialty, ANA\u2019s certification prep materials ensure you are studying with the highest quality resources. Maximize your exam readiness and achieve your certification goals with the support of PracticeIQ. Start your comprehensive review today and take the next step in advancing your nursing career.",
        "learning_objectives_html": "The key learning objectives for this activity are:\r\n<br />\r\n&bull;\tPrepare for the NEA-BC&reg; exam based on the ANCC Test Content Outline effective November 11, 2025",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "29A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C01FDB4F-F53E-E711-B09D-005056B10493",
                "course_category_name": "Leadership & Workforce Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 21.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];